import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { motion } from 'framer-motion';
import { Anchor, Zap, Trophy, Timer, Waves, Sunrise } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function SurfskiPage() {
  useEffect(() => {
    // Set meta tags for Surfski page
    document.title = "קיאק Surfski | ביץ' קלאב מעגן";
    // Update or create meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'חתירה בקיאק Surfski בכנרת - מהירות, אדרנלין וטכניקה או חתירה רגועה ונופי הכנרת. הדרכות וקבוצות אימון');
    // Open Graph tags with image
    const ogTags = [{
      property: 'og:title',
      content: "קיאק Surfski | ביץ' קלאב מעגן"
    }, {
      property: 'og:description',
      content: 'חתירה בקיאק Surfski בכנרת - מהירות ואדרנלין או חתירה רגועה. הדרכות אישיות וקבוצות אימון'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png'
    }, {
      property: 'og:image:width',
      content: '1200'
    }, {
      property: 'og:image:height',
      content: '630'
    }, {
      property: 'og:url',
      content: window.location.href
    },
    // Twitter Card tags
    {
      property: 'twitter:card',
      content: 'summary_large_image'
    }, {
      property: 'twitter:title',
      content: "קיאק Surfski | ביץ' קלאב מעגן"
    }, {
      property: 'twitter:description',
      content: 'חתירה בקיאק Surfski בכנרת - מהירות ואדרנלין'
    }, {
      property: 'twitter:image',
      content: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png'
    }];
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', tag.content);
    });
  }, []);
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-1675">
      <Navigation data-id="element-1676" />

      {/* Hero Section */}
      <div className="relative h-[60vh] overflow-hidden" data-id="element-1677">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-1678" />
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7vRPckyZqmqZUztC54T3ts/image_%287%29.png" alt="Surfski Activity" className="w-full h-full object-cover" data-id="element-1679" />
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center text-white px-4" data-id="element-1680">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-bold mb-4" data-id="element-1681">
            קיאק Surfski
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl max-w-2xl font-light" data-id="element-1682">
            מהירות, אדרנלין וטכניקה על המים - או סתם חתירה רגועה ונופי הכנרת
          </motion.p>
        </div>
      </div>

      {/* Content Section */}
      <div className="container mx-auto px-4 py-20" data-id="element-1683">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-1684">
          <div data-id="element-1685">
            <h2 className="text-3xl font-bold text-[#0A5F8F] mb-6" data-id="element-1686">
              על הפעילות
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-8" data-id="element-1687">
              ה-Surfski הוא קיאק פתוח, צר וארוך, המיועד לחתירה מהירה ולגלישת
              גלים (Downwind). זהו ספורט המשלב כושר גופני אירובי ברמה גבוהה עם
              מיומנות טכנית של קריאת הים ותפיסת גלים. במועדון שלנו תמצאו את
              הקיאקים הטובים בעולם מבית המותגים המובילים.
            </p>

            {/* Relaxed Paddling Section */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-blue-50 to-cyan-50 border border-blue-100 rounded-2xl p-6 mb-8" data-id="element-1688">
              <div className="flex items-start gap-4" data-id="element-1689">
                <div className="bg-white p-3 rounded-xl shadow-sm" data-id="element-1690">
                  <Sunrise className="w-6 h-6 text-blue-500" data-id="element-1691" />
                </div>
                <div data-id="element-1692">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1693">
                    חתירה רגועה ונופי הכנרת
                  </h3>
                  <p className="text-gray-700 leading-relaxed" data-id="element-1694">
                    לא חייבים להיות ספורטיביים! הקיאק מושלם גם לחתירה רגועה
                    ונינוחה על מי הכנרת השקטים. תיהנו מהשקט, מהנוף המדהים של
                    ההרים מסביב, ומחוויה מדיטטיבית של חיבור לטבע. מתאים במיוחד
                    לזריחות ושקיעות קסומות.
                  </p>
                </div>
              </div>
            </motion.div>

            <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-1695">
              למי זה מתאים?
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-1696">
              {['חותרים המחפשים אתגר פיזי ומנטלי', 'אוהבי אדרנלין ומהירות', 'מי שרוצה חתירה רגועה ולהנות מנופי הכנרת', 'מי שרק בא לו להרגע ולהתנתק מהשגרה', 'אנשים עם רקע בחתירה (אך לא חובה, יש קורסי מתחילים)', 'מי שרוצה לשפר את הכושר האירובי בצורה משמעותית'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-1697">
                  <div className="bg-indigo-100 p-1 rounded-full" data-id="element-1698">
                    <Zap className="w-4 h-4 text-indigo-600" data-id="element-1699" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-1700">
            <h3 className="text-2xl font-bold text-[#0A5F8F] mb-6" data-id="element-1701">
              מה אנחנו מציעים?
            </h3>

            <div className="space-y-6" data-id="element-1702">
              <div className="flex gap-4" data-id="element-1703">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1704">
                  <Anchor className="w-6 h-6 text-indigo-500" data-id="element-1705" />
                </div>
                <div data-id="element-1706">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1707">
                    הדרכות אישיות ברמות שונות
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1708">
                    ליווי אישי מותאם לרמתך - ממתחילים מוחלטים ועד חותרים
                    מתקדמים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1709">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1710">
                  <Waves className="w-6 h-6 text-indigo-500" data-id="element-1711" />
                </div>
                <div data-id="element-1712">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1713">הדרכות קבוצתיות</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1714">
                    אימונים קבוצתיים באווירה תומכת ומעצימה, מחולקים לפי רמות.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1715">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1716">
                  <Zap className="w-6 h-6 text-indigo-500" data-id="element-1717" />
                </div>
                <div data-id="element-1718">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1719">קהילה שוקקת</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1720">
                    הצטרפו לקהילת חותרים פעילה ומגובשת שחולקת את אהבת המים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1721">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1722">
                  <Trophy className="w-6 h-6 text-indigo-500" data-id="element-1723" />
                </div>
                <div data-id="element-1724">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1725">
                    אירועי חתירה ספורטיביים
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1726">
                    חתירות וטיולים חוויתיים, שקיעה וזריחה, חציית הכנרת ועוד
                    מפגשים.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1727">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1728">
                  <Timer className="w-6 h-6 text-indigo-500" data-id="element-1729" />
                </div>
                <div data-id="element-1730">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1731">אחסנת ציוד אישי</h4>
                  <p className="text-gray-600 text-sm" data-id="element-1732">
                    אפשרות לאחסון הציוד האישי שלכם במועדון בנוחות ובבטחה.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1733">
                <div className="bg-white p-3 rounded-xl shadow-sm h-fit" data-id="element-1734">
                  <Waves className="w-6 h-6 text-indigo-500" data-id="element-1735" />
                </div>
                <div data-id="element-1736">
                  <h4 className="font-bold text-lg mb-1" data-id="element-1737">
                    שימוש חופשי בציוד המועדון
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1738">
                    חברי המועדון נהנים משימוש חופשי בציוד החתירה החדיש והאיכותי
                    של המועדון לחתירות עצמאיות.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-1739">
              <Button className="w-full text-lg py-6" onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-1740">
                הצטרפו לאימון ניסיון
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ContactSection data-id="element-1741" />
      <Footer data-id="element-1742" />
    </div>;
}